import { FormControl, InputLabel, MenuItem, Select, Autocomplete, TextField } from "@mui/material";
import get from "lodash.get";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import {getSearchIllnesessData} from "../../utils/API";

function SelectComponent2(props) {
    const {
        menuItem = [],
        label,
        setSelections,
        required = false,
        procedureName = null,
        multiple = false,
        mode,
        minWidth = "120px",
        disabledoption=true
    } = props;
    const [selection, setSelection] = useState(
        mode === "entity"
            ? {
                displayName: "Initimation Number",
                id: "INTIMATION_NUMBER",
            }
            : mode === "date"
                ? { id: "DATE_UPDATED", name: "Updated Date" }
                : ""
    );
    const handleChange = (event) => {
        setSelection(event.target.value);
    };
    const handleAutocompleteChange = (event, value) => {
        setSelection(value);
    };

    useEffect(() => {
        setSelections(selection);
    }, [selection]);
    useEffect(() => {
        if (Array.isArray(menuItem) && menuItem.length > 0) {
            setMenuItemSet(menuItem);
        }
    }, [menuItem]);

    const [menuItemSet, setMenuItemSet] = useState([menuItem]);
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);

    const searchIllness = async (keyword) => {
        if (!keyword || keyword.length < 2) return;

        setLoading(true);

        try {
            const res = await getSearchIllnesessData(keyword);

            // ✅ extract array safely (adjust path if needed)
            const list =
                Array.isArray(res?.data)
                    ? res.data
                    : Array.isArray(res?.data?.data)
                        ? res.data.data
                        : Array.isArray(res?.data?.data?.illnessList)
                            ? res.data.data.illnessList
                            : [];

            setMenuItemSet(list);
        } catch (error) {
            console.error("Search illness failed", error);
            setMenuItemSet([]); // fallback
        } finally {
            setLoading(false);
        }
    };


    return (
        <div>
            <FormControl
                variant="standard"
                fullWidth
                sx={{ m: 1, minWidth: minWidth }}
            >
                <InputLabel id="demo-simple-select-standard-label" required={required}>
                    {label}
                </InputLabel>
                {!multiple &&
                //     <Select
                //     labelId="demo-select-small-label"
                //     id="demo-select-small"
                //     label=""
                //     value={typeof selection === "object" ? selection.id : selection}
                //     onChange={handleChange}
                //     displayEmpty
                // >
                //     {procedureName && (
                //         <MenuItem disabled value="">
                //             <p style={{ margin: 0, textAlign: "left" }}>{procedureName}</p>
                //         </MenuItem>
                //     )}
                //
                //     {menuItem.length > 0 &&
                //         menuItem.map((item, index) => (
                //             <MenuItem
                //                 value={
                //                     item.illnessName + ' - ' + item.defaultICDCode
                //                 }
                //                 key={index}
                //                 style={{ padding: 8 }}
                //             >
                //                 {" "}
                //                 {
                //                     item.illnessName + ' - ' + item.defaultICDCode
                //                 }
                //             </MenuItem>
                //         ))}
                // </Select>
                //
                    <Autocomplete
                    id="illness-autocomplete"
                    options={menuItemSet}
                getOptionLabel={(option) =>
                    option?.illnessName
                        ? `${option.illnessName}`
                        : "Select"
                }
                    {...(disabledoption && {
                        getOptionDisabled: (option) =>
                            option.active === false &&
                            option.illnessName !== "Select"
                    })}
                    // disable logic
                    value={selection.id}

                onChange={(event, newValue) => {
                    // Convert selected object to string and pass via synthetic event
                    handleChange({
                        target: {
                            value: newValue? newValue: "",
                        },
                    });
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={procedureName || ""}
                        variant="standard"

                        InputLabelProps={{
                            style: { color: '#000' } // black or any dark color
                        }}/>
                )}
                isOptionEqualToValue={(option, value) =>
                    `${option.illnessName}` ===`${value.illnessName}`
                }
                    inputValue={inputValue}           // ✅ TEXT
                    loading={loading}
                    onInputChange={(event, newInputValue, reason) => {
                        // if (reason !== "input") return; // ✅ ignore reset/clear

                        const searchText = newInputValue?.toString();

                        setInputValue(searchText);

                        if (!searchText || searchText.length < 2) return;

                        const exists = menuItemSet.some(item =>
                            item.illnessName
                                ?.toLowerCase()
                                .includes(searchText.toLowerCase())
                        );

                        if (!exists) {
                            searchIllness(searchText); // ✅ STRING ONLY
                        }
                    }}

                    clearOnEscape
            />

            }
                {multiple && <Autocomplete
                    multiple
                    id="tags-standard"
                    sx={{ mt: '1rem' }}
                    options={menuItemSet}
                    getOptionLabel={(option) =>
                        option?.illnessName
                            ? `${option.illnessName}`
                            : "Select"
                    }
                    onChange={handleAutocompleteChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                        />
                    )}

                    inputValue={inputValue}           // ✅ TEXT
                    loading={loading}
                    onInputChange={(event, newInputValue, reason) => {
                        // if (reason !== "input") return; // ✅ ignore reset/clear

                        const searchText = newInputValue?.toString();

                        setInputValue(searchText);

                        if (!searchText || searchText.length < 2) return;

                        const exists = menuItemSet.some(item =>
                            item.illnessName
                                ?.toLowerCase()
                                .includes(searchText.toLowerCase())
                        );

                        if (!exists) {
                            searchIllness(searchText); // ✅ STRING ONLY
                        }
                    }}
                />}
            </FormControl>
        </div>
    );
}

export default SelectComponent2;
